













































import { Component, Vue, Provide } from "vue-property-decorator";
import IdentifyInfo from "./components/IdentifyInfo.vue";
import OtherInfo from "./components/OtherInfo.vue";
import Table from "@/components/table.vue";
import {API_COUNTRY} from '@/api/root';
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";

@Component({
  name: "orderDeal",
  components: { IdentifyInfo, OtherInfo, Table }
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "idInfo";
  @Provide() private isContainCreditInfo: boolean = false; // 2021-06-07  lin 判断是不是包含增新信息的选项
  @Provide() private tableData: any = [{ opUid: 123, phoneObject: 22 }];
  @Provide() private changeTableData: any = [{ opUid: 123, phoneObject: 22 }];
  @Provide() private labelData: any = [
    { label: "userInfo.loanHistory", value: "orderid" },
    { label: "userInfo.loanAmount", value: "amount" },
    { label: "userInfo.TheTerm", value: "loanperiod" },
    { label: "userInfo.State", value: "loanstatus" },
    { label: "userInfo.applyTime", value: "applytime" },
    { label: "userInfo.processingTime", value: "checktime" },
    { label: "userInfo.loanTime", value: "loantime" },
    { label: "userInfo.closingTime", value: "finishtime" },
    { label: "userInfo.overdueDays", value: "overduedays" }
  ];
  @Provide() private changeLabelData: any = [
    { label: "id", value: "id" },
    { label: "userInfo.AccountNumber", value: "accountid" },
    { label: "userInfo.UpdateItems", value: "recordtype" },
    { label: "userInfo.OriginalValue", value: "original" },
    { label: "userInfo.TheCurrentValue", value: "edit" },
    { label: "userInfo.TimeChange", value: "ctime" },
    { label: "userInfo.ModifiedBy", value: "opuid" }
  ];
  @Provide() private API_COUNTRY: any = API_COUNTRY;
  @Provide() private basicInfo: any = [];
  @Provide() private otherInfo: any = [];
  @Provide() private creditInfo: any = [];
  @Provide() private creditInfoTitle: string = "";
  @Provide() private pageSize: any = 20; //分页页数
  @Provide() private pagerCount: any = 0; //总条数
  @Provide() private changePageCount: any = 0;
  @Provide() private imgsInfo: any = [];
  @Provide() private env: any = window.location.href;

  private created() {
    this.getCustomerDetail(0, this.pageSize);
  }

  private refreshTable(pageIndex: number, pageSize: number) {
    this.getCustomerDetail(pageIndex, pageSize);
  }

  private getCustomerDetailFuc(data: any) {
    console.log(data, "haha");
    if (data.detailtabsList) {
      if (
        data.detailtabsList.length > 0 &&
        data.detailtabsList[0].sectionsList.length > 1
      ) {
        this.basicInfo = data.detailtabsList[0].sectionsList[0];
        this.imgsInfo = data.detailtabsList[0].sectionsList[1];
      }
      if (data.detailtabsList.length > 1) {
        this.otherInfo = data.detailtabsList[1].sectionsList;
      }
      if (data.detailtabsList.length > 2) {
        this.creditInfoTitle = data.detailtabsList[2].tabname;
        this.creditInfo = data.detailtabsList[2].sectionsList;
      }
    }

    data.loanhistoryList.forEach((item: any) => {
      item.applytime = item.applytime && timeFormat(item.applytime);
      item.checktime = item.checktime && timeFormat(item.checktime);
      item.loantime = item.loantime && timeFormat(item.loantime);
      item.finishtime = item.finishtime && timeFormat(item.finishtime);
    });
    this.tableData = data.loanhistoryList;
    this.pagerCount = data.totalloanhistory;

    data.changelogList.forEach((item: any) => {
      item.ctime = item.ctime && timeFormat(item.ctime);
    });
    this.changeTableData = data.changelogList;
    this.changePageCount = data.totalchangelog;
  }
  private async getCustomerDetail(pageIndex: number, pageSize: number) {
    const { setGetCustomerDetailReq, getCustomerDetailRequest }: any = await import(
            "@/request/getCustomerDetail"
            );
    console.log(typeof getCustomerDetailRequest);
    console.log(getCustomerDetailRequest,"getCustomerDetailRequest");
    let data = await getCustomerDetailRequest.handleHttp(setGetCustomerDetailReq({
      id: this.$route.query.id,
      appname: this.$route.query.appname,
      pageIndex: pageIndex,
      pageSize: pageSize
    }), this);
    console.log(data, "--------------------getCustomerDetail");
    if (data.detailtabsList) {
      if (
              data.detailtabsList.length > 0 &&
              data.detailtabsList[0].sectionsList.length > 0
      ) {
        this.basicInfo = data.detailtabsList[0].sectionsList[0];
        this.imgsInfo = data.detailtabsList[0].sectionsList.length > 1? data.detailtabsList[0].sectionsList[1] : [];
      }
      if (data.detailtabsList.length > 1) {
        this.otherInfo = data.detailtabsList[1].sectionsList;
      }
      if (data.detailtabsList.length > 2) {
        this.creditInfoTitle = data.detailtabsList[2].tabname;
        this.creditInfo = data.detailtabsList[2].sectionsList;
        this.isContainCreditInfo = true;  // 2021-06-07 lin 增加是否显示增新信息的判断开关
      }
    }

    data.loanhistoryList.forEach((item: any) => {
      item.applytime = item.applytime && timeFormat(item.applytime);
      item.checktime = item.checktime && timeFormat(item.checktime);
      item.loantime = item.loantime && timeFormat(item.loantime);
      item.finishtime = item.finishtime && timeFormat(item.finishtime);
    });
    this.tableData = data.loanhistoryList;
    this.pagerCount = data.totalloanhistory;

    data.changelogList.forEach((item: any) => {
      item.ctime = item.ctime && timeFormat(item.ctime);
    });
    this.changeTableData = data.changelogList;
    this.changePageCount = data.totalchangelog;
  }
  // private getCustomerDetail(pageIndex: number, pageSize: number) {
  //   const getOrderListReq: any = new GetCustomerDetailReq();
  //   getOrderListReq.setCommonin(setCommon());
  //   getOrderListReq.setAccountid(this.$route.query.id);
  //   getOrderListReq.setPagein(setPage(pageIndex, pageSize));
  //   collectionServiceClient.getCustomerDetail(
  //     getOrderListReq,
  //     setMetaData(),
  //     (err: any, response: any) => {
  //       console.log(response);
  //       console.log(err);
  //       if (response) {
  //         const data: any = response.toObject();
  //         console.log(data);
  //         let _fuc = this.getCustomerDetailFuc;
  //         handleResponse(data, _fuc);
  //         // if (!data.commonout || (data.commonout.code == 0)) {
  //         //   this.basicInfo = data.detail.baseinfo.identityinfoMap;
  //         //   this.imgsInfo = data.detail.baseinfo.imageinfoMap; // 图像信息
  //         //
  //         //   this.otherInfo[0].content = data.detail.otherinfo.accountinfoMap;
  //         //   this.otherInfo[1].content = data.detail.otherinfo.repayinfoMap;
  //         //   this.otherInfo[2].content = data.detail.otherinfo.workinfoMap;
  //         //   this.otherInfo[3].content = data.detail.otherinfo.contactinfoMap;
  //         //
  //         //   data.loanhistoryList.forEach((item: any) => {
  //         //       item.applytime = item.applytime && timeFormat(item.applytime);
  //         //       item.checktime = item.checktime && timeFormat(item.checktime);
  //         //       item.loantime = item.loantime && timeFormat(item.loantime);
  //         //       item.finishtime = item.finishtime && timeFormat(item.finishtime);
  //         //   });
  //         //   this.tableData = data.loanhistoryList;
  //         //   this.pagerCount = data.totalloanhistory;
  //         //
  //         //   data.changelogList.forEach((item: any) => {
  //         //       item.ctime = item.ctime && timeFormat(item.ctime);
  //         //   });
  //         //   this.changeTableData = data.changelogList;
  //         //   this.changePageCount = data.totalchangelog;
  //         // }  else if (data.code == 102) {
  //         //   // this.pagerCount = 0;
  //         //   // this.resultData = [];
  //         // } else {
  //         //   this.$message.error(data.commonout.errmsg);
  //         // }
  //       }
  //     }
  //   );
  // }
}
